import { Box } from '@material-ui/core';
import React from 'react';

import { HorizontalProgressBar } from '@/components/shared/components/HorizontalProgressBar';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface DocumentationRequiredProgressBarProps {
  uploadedProgress: number;
  selected?: boolean;
  boxProps?: React.ComponentProps<typeof Box>;
}

export const DocumentationRequiredProgressBar = ({
  uploadedProgress,
  selected = false,
  boxProps,
}: DocumentationRequiredProgressBarProps) => {
  const { palette } = useCustomTheme();
  return (
    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} ml={1} {...boxProps}>
      <HorizontalProgressBar
        progressValue={uploadedProgress}
        color={selected ? palette.secondary.contrastText : palette.secondary.main}
        bgColor={selected ? palette.secondary.light : palette.grey[200]}
        style={{ margin: 0 }}
      />
    </Box>
  );
};
